/*@ngInject*/
const FormTemplateBrowserController = function ($rootScope, $scope, $uibModal, $filter, localization, advancedFilterType, filterType, uIFormTemplateAction, configurationMediator, configurationActionsUtil, databaseDownloadSectionName, modalUtil, gridDataBrowserConstant) {

    localization.getTranslationByKey('formTemplateBrowser').then(function (translations) {

        $scope.columns = [{
            name: 'type',
            label: _.get(translations, 'columns.type'),
            className: 'colType',
            getValue: function (item) {
                return _.get(translations, 'type.' + item.type);
            }
        }, {
            name: 'products',
            label: _.get(translations, 'columns.products'),
            className: 'colProducts',
            getValue: function (item) {
                var products = '';

                if (_.isEmpty(item.productTemplates)) {
                    products = _.get(translations, 'allProducts');
                } else {
                    products = item.productTemplateShortNames;
                }

                return products;
            }
        }, {
            name: 'uniqueName',
            label: _.get(translations, 'columns.uniqueName'),
            className: 'colUniqueName',
            getValue: function (item) {
                return item.uniqueName;
            }
        }, {
            name: 'displayName',
            label: _.get(translations, 'columns.displayName'),
            className: 'colDisplayName',
            getValue: function (item) {
                return item.displayName;
            }
        }, {
            name: 'version',
            label: _.get(translations, 'columns.version'),
            className: 'colVersion',
            getValue: function (item) {
                return item.version;
            }
        }, {
            name: 'visibility',
            label: _.get(translations, 'columns.visibility'),
            className: 'colVisibility',
            getValue: function (item) {
                return item.visibility;
            }
        }, {
            name: 'lastModifiedBy',
            label: _.get(translations, 'columns.name'),
            className: 'colName',
            getValue: function (item) {
                return item.lastModifiedBy;
            }
        }, {
            name: 'lastModifiedDate',
            label: _.get(translations, 'columns.lastModifiedDate'),
            className: 'colLastModifiedDate',
            getValue: function (item) {
                return $filter('date')(item.timeLastModified, 'MM/dd/yy hh:mma');
            }
        }];

        $scope.advancedFilterType = advancedFilterType.FORM_TEMPLATE_BROWSER;
        $scope.filterType = filterType.TYPE_FORMTEMPLATE_FILTER;

        $scope.stateParams = {
            browser: 'configuration.formTemplateBrowser',
            getDetailState: function (formTemplate) {
                return {
                    name: 'configuration.formEditor.form',
                    params: {
                        uiFormTemplateId: formTemplate.id
                    }
                };
            }
        };

        $scope.translations = {
            title: _.get(translations, 'title'),
            recordCountText: _.get(translations, 'recordCountText'),
            recordsCountText: _.get(translations, 'recordsCountText'),
            emptyGrid: _.get(translations, 'emptyGrid'),
            bulkActionLabel: _.get(translations, 'bulkActionLabel'),
            bulkActionCancelButtonLabel: _.get(translations, 'bulkActionCancelButtonLabel')
        };

        $scope.initialRequestParams = {
            key: 'type',
            startIndex: 0,
            pageSize: 25,
            sortType: 'asc'
        };

        $scope.loadActionsHandler = function () {
            return configurationMediator.loadFormTemplateBrowserActions().then(function (actions) {
                _.each(actions.actions, function (action) {
                    if (action.name === uIFormTemplateAction.EXPORT) {
                        action.isBulkAction = true;
                        action.bulkActionLabel = _.get(translations, 'exportFormTemplates.bulkActionLabel');
                    }

                    if (action.name === uIFormTemplateAction.MARK_IN_PRODUCTION) {
                        action.isBulkAction = true;
                        action.bulkActionLabel = _.get(translations, 'markInProduction.bulkActionLabel');
                    }

                    if (action.name === uIFormTemplateAction.PUBLISH_FORM_TEMPLATES) {
                        action.isBulkAction = true;
                        action.bulkActionLabel = _.get(translations, 'createFormTemplateSet.bulkActionLabel');
                    }
                });

                actions.hiddenInputActions = {};
                actions.hiddenInputActions[uIFormTemplateAction.IMPORT] = 'application/xml';

                return actions;
            });
        };

        $scope.loadItemsHandler = function (filterUri, requestParams) {
            return configurationMediator.getUiFormTemplatesByFilterUri(filterUri, requestParams);
        };

        $scope.handleAction = function (action, file) {
            if (action.enabled) {
                switch (action.name) {
                    case uIFormTemplateAction.NEW_FORM:
                        $uibModal.open({
                            templateUrl: '/configuration/formTemplateSettings/formTemplateSettingsTemplate.tpl.html',
                            controller: 'formTemplateSettingsController',
                            windowClass: 'formTemplateSettingsModal',
                            resolve: {
                                options: {
                                    formTemplateId: null
                                }
                            }
                        });
                        break;


                    case uIFormTemplateAction.RELOAD_FORM_RULES:
                        configurationActionsUtil.reloadFormRules();
                        break;

                    case uIFormTemplateAction.RELOAD_FIELD_RULES:
                        configurationActionsUtil.reloadFieldRules();
                        break;

                    case uIFormTemplateAction.IMPORT:
                        configurationActionsUtil.importFormTemplates(file, translations);
                        break;

                    case uIFormTemplateAction.BACKUP:
                        configurationActionsUtil.backup(databaseDownloadSectionName.FORM_TEMPLATES, _.get(translations, 'backup.name'), _.get(translations, 'backup.loadingBar'), _.get(translations, 'backup.successMessage'));
                        break;

                    case uIFormTemplateAction.TEST_DRAFT_FORM_TEMPLATES:
                        configurationActionsUtil.createTestFormTemplateSet();
                        break;

                    default:
                        modalUtil.showActionNotImplementedModal(action.name);
                        break;
                }
            }
        };

        $scope.handleBulkAction = function (action, selectedItems, excludedItems, filterUri) {
            if (action.enabled) {
                switch (action.name) {
                    case uIFormTemplateAction.EXPORT:
                        configurationActionsUtil.exportFormTemplates(selectedItems, filterUri, excludedItems, 'formTemplateBrowser.exportFormTemplates.loadingBar').then(function () {
                            $rootScope.$broadcast(gridDataBrowserConstant.event.BULK_ACTION_COMPLETE);
                        });
                        break;

                    case uIFormTemplateAction.MARK_IN_PRODUCTION:
                        configurationActionsUtil.markFormTemplatesInProduction(selectedItems, filterUri, excludedItems).then(function () {
                            $rootScope.$broadcast(gridDataBrowserConstant.event.BULK_ACTION_COMPLETE);
                        });
                        break;

                    case uIFormTemplateAction.PUBLISH_FORM_TEMPLATES:
                        configurationActionsUtil.publishFormTemplates('formTemplateBrowser.createFormTemplateSet.loadingBar', selectedItems, filterUri, excludedItems).then(function(){
                            $rootScope.$broadcast(gridDataBrowserConstant.event.BULK_ACTION_COMPLETE);
                        });
                        break;
                    default:
                        modalUtil.showActionNotImplementedModal(action.name);
                        $rootScope.$broadcast(gridDataBrowserConstant.event.BULK_ACTION_COMPLETE);
                        break;
                }
            }
        };
    });
};

angular.module('ums.configuration')
    .controller('formTemplateBrowserController', FormTemplateBrowserController);
